import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, contentChildren, input, model, TemplateRef, viewChild } from "@angular/core";
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "primeng/tabs";

@Component({
    selector: "kno2-tab",
    template: `
        <ng-template #headerTpl>
            {{ header() }}
            <ng-content select="[kno2TabHeader]" />
        </ng-template>
        <ng-template #bodyTpl>
            <ng-content />
        </ng-template>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabComponent {
    public readonly value = input.required<string>();
    public readonly header = input<string>();
    public readonly headerTemplate = viewChild.required<TemplateRef<unknown>>("headerTpl");
    public readonly bodyTemplate = viewChild.required<TemplateRef<unknown>>("bodyTpl");
}

@Component({
    selector: "kno2-tabs",
    imports: [Tabs, TabList, Tab, TabPanels, TabPanel, NgTemplateOutlet],
    template: `
        <p-tabs
            [value]="value()"
            (valueChange)="value.set($any($event))">
            <p-tablist>
                @for (tab of tabs(); track tab.value()) {
                    <p-tab [value]="tab.value()">
                        <ng-container [ngTemplateOutlet]="tab.headerTemplate()" />
                    </p-tab>
                }
            </p-tablist>
            <p-tabpanels>
                @for (tab of tabs(); track tab.value()) {
                    <p-tabpanel [value]="tab.value()">
                        <ng-container [ngTemplateOutlet]="tab.bodyTemplate()" />
                    </p-tabpanel>
                }
            </p-tabpanels>
        </p-tabs>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsComponent {
    public readonly value = model<string>();
    public readonly tabs = contentChildren(TabComponent);
}
